import { Button } from "@mui/material";
import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      variant="outlined"
      sx={{
        display: "flex",
        marginBottom: "1rem",
        gap: "0.5rem",
        color: "#DA2128",
        borderColor: "#DA2128",
        "&:hover": {
          borderColor: "#DA2128",
          color: "#DA2128",
        },
      }}
      onClick={() => navigate(-1, { replace: true })}
    >
      <FaArrowLeft /> Back
    </Button>
  );
};

export default BackButton;
